class CollectionAltImagesToggle extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['toggle']
  }

  setupListeners () {
    super.setupListeners()

    this.apply = this.apply.bind(this)
    this.applyState = this.applyState.bind(this)
    this.disablePulse = this.disablePulse.bind(this)

    this.apply()

    this.listeners.add(this.els.toggle.element, 'change', event => {
      this.applyState(event.target.checked)
      this.disablePulse()
    })

    this.listeners.add(this.els.toggle.element, 'pointerdown', this.disablePulse, {
      once: true,
    })
  }

  apply () {
    const plpContainer = document.querySelector(
      '[data-collection-alt-images-toggle-external-el="grid"]',
    )
    if (!plpContainer) return

    const toggle = this.els.toggle.element
    if (!toggle) return

    const isEnabled = plpContainer.classList.contains('plp--alt-images')
    if (toggle.checked !== isEnabled) {
      toggle.checked = isEnabled
    }
  }

  applyState (isEnabled) {
    const plpContainer = document.querySelector(
      '[data-collection-alt-images-toggle-external-el="grid"]',
    )
    if (!plpContainer) return

    plpContainer.classList.toggle('plp--alt-images', isEnabled)

    document
      .querySelectorAll('[data-collection-alt-images-toggle-el="toggle"]')
      .forEach(input => {
        input.checked = isEnabled
      })

    plpContainer.querySelectorAll('.prd-Card_Images').forEach(imagesEl => {
      imagesEl.scrollLeft = 0
    })
  }

  disablePulse () {
    this.classList.remove('clc-ProductGrid_AltImagesToggle--pulse')
  }
}

if (!customElements.get('collection-alt-images-toggle')) {
  customElements.define('collection-alt-images-toggle', CollectionAltImagesToggle)
}

